var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8334 15.9993C29.8334 23.36 23.8662 29.3327 16.5001 29.3327C9.13396 29.3327 3.16675 23.3655 3.16675 15.9993C3.16675 8.63869 9.13396 2.66602 16.5001 2.66602C23.8662 2.66602 29.8334 8.63323 29.8334 15.9993Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1039_30772",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9.04492H9.83325V24.5872H24.5V9.04492Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1039_30772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3942 15.4464L23.7492 9.35547H22.4802L17.8304 14.6442L14.1166 9.35547H9.83325L15.4492 17.3529L9.83325 23.7402H11.1023L16.0126 18.1552L19.9346 23.7402H24.218L18.3942 15.4464ZM16.656 17.4234L16.087 16.6271L11.5596 10.2902H13.5088L17.1624 15.4042L17.7314 16.2006L22.4808 22.8479H20.5316L16.656 17.4234Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.bcf674dc2b553ee21428cb2e44802ac5.svg";
export { ForwardRef as ReactComponent };